export default __webpack_public_path__ + "assets/favicons/mstile-150x150.png";